/* eslint-disable */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toCurrency } from '../../utils/CurrencyUtil'
import { Checkbox } from '../../Components/ui/checkbox'
import { Button } from '../../Components/ui/button'
import env from '../../env/env'
import placeholder from '../../assets/placeholder.svg'
import useMediaQuery from '../../hooks/useMediaQuery'
import { ChevronLeft } from 'lucide-react'
import { MFUserBaskets, MFUserSubsequentBaskets } from '../../store/MFBasketsStore'
import { useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValueLoadable } from 'recoil'
import { addNumberSuffix, capitalizeWords } from '../../utils/Util'
import { useModal } from '../../hooks/use-modal-store'
import { userDetailsState } from '../LoginState'

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import { BankDetails } from '../../store/AccountDetailsStore'
import { AccountBalance } from '@mui/icons-material'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { CalendarIcon, Pen } from 'lucide-react'
import { addMonth, formatIndianNumber, monthShortNames } from '../../utils/Util'
import refresh from '../../assets/SVGS/refresh.svg'
import { Card } from '../../Components/ui/card'
import { post } from '../../http/restservice'
import { useErrorPopup } from '../../hooks/useErrorPopup'

import OrderOtpVerification from './OrderOtpVerification'
import clevertap from 'clevertap-web-sdk'
import { isDematUser } from '../../utils/AuthUtil'
import { messageModalState } from '../../store/Feedback'
import { useSetRecoilState } from 'recoil'

const UserBankDetails = ({ day, flowStep }) => {
  const [src, setSrc] = useState('')
  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)

  let ifscCode = bankDetails?.ifscCode
  const extractedBranch = ifscCode?.match(/^[A-Za-z]{4}/)[0]?.toLowerCase()
  const iconSrc = `${env.BANK_LOGOS}/${extractedBranch}/symbol.svg`

  useEffect(() => {
    setSrc(iconSrc)
  }, [iconSrc])

  return (
    <>
      {flowStep === 0 ? (
        <div>
          <h3 className='text-nowrap flex gap-x-1 items-center text-black-400 mb-2'>
            Pay with just <span className='text-primary-700 font-semibold'>One Tap</span>
          </h3>
          <Card
            className={`cursor-pointer p-4 rounded-xl flex items-center gap-3 font-DMSans ${
              flowStep === 0 && 'bg-[#F4F7FE]'
            }`}
          >
            <div className='relative'>
              <div className='flex-shrink-0'>
                {src ? (
                  <div className='h-11 w-11 rounded-full border border-[#D3DBEC] flex justify-center items-center'>
                    <img
                      src={src}
                      alt='bank logos'
                      onError={() => {
                        setSrc(null)
                      }}
                      height={24}
                      width={24}
                    />
                  </div>
                ) : (
                  <AccountBalance className='text-primary-200' />
                )}
              </div>
              <div className='absolute -bottom-1 -right-1 w-6 h-6 flex items-center justify-center'>
                <img
                  src={refresh}
                  alt='bank logos'
                  onError={() => {
                    setSrc(null)
                  }}
                  height={24}
                  width={24}
                />
              </div>
            </div>
            <div className='flex-1'>
              <div className='font-medium'>
                Mandate{' '}
                <span className='text-xs text-black-500'>(Takes 3 to 4 days to activate)</span>
              </div>
              <div className='text-sm text-black-400'>
                {' '}
                {capitalizeWords(bankDetails && bankDetails?.bankName)} A/c ending in{' '}
                <strong>
                  {bankDetails && bankDetails?.accountNo && bankDetails?.accountNo?.slice(-4)}
                </strong>
              </div>
            </div>
          </Card>
        </div>
      ) : (
        <div className=''>
          <h1 className='font-DMSans font-normal text-sm lg:text-lg text-black-400'>Bank</h1>

          <div className='p-4 flex items-center gap-4 rounded-[16px] border border-[#D3DBEC] mt-2'>
            <div className='flex-shrink-0'>
              {src ? (
                <div className='h-[35.56px] w-[35.56px] rounded-full border border-[#D3DBEC] flex justify-center items-center'>
                  <img
                    src={src}
                    alt='bank logos'
                    onError={() => {
                      setSrc(null)
                    }}
                    height={24}
                    width={24}
                  />
                </div>
              ) : (
                <AccountBalance className='text-primary-200' />
              )}
            </div>
            <div className='flex flex-col'>
              <span className='text-[#2f3c5a] font-semibold'>
                {bankDetails && bankDetails?.accountHolderName}
              </span>
              <span className='text-[#2f3c5a] text-xs'>
                {bankDetails && bankDetails?.bankName} A/c ending in{' '}
                <strong>
                  {bankDetails && bankDetails?.accountNo && bankDetails?.accountNo?.slice(-4)}
                </strong>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const UserActionPlan = () => {
  const navigate = useNavigate()
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)
  const { state, contents: investedPlans } = useRecoilValueLoadable(MFUserBaskets)
  const seubsequentPlans = useRecoilValueLoadable(MFUserSubsequentBaskets)
  const refreshMFUserBaskets = useRecoilRefresher_UNSTABLE(MFUserBaskets)
  const refreshMFUserSubsequent = useRecoilRefresher_UNSTABLE(MFUserSubsequentBaskets)
  const [adminPlans, setAdminPlans] = useState([])
  const [openPlans, setOpenPlans] = useState({})
  const [selectedPlans, setSelectedPlans] = useState([])
  const [isAllSelected, setIsAllSelected] = useState(true)
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  // SIPs & OT
  const [flowStep, setFlowStep] = useState(0)
  const sipDates = [3, 5, 10, 15, 22, 25]
  const [sipDate, setSipDate] = useState('')
  const currentDate = new Date()
  const today = currentDate.getDate()
  const [selectedDay, setSelectedDay] = useState(5)
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [loading, setLoading] = useState(false)
  const email = userDetails?.email
  const userData = JSON.parse(localStorage.getItem('userData'))
  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : userData?.uid?.split('-')[0]

  const setMessageModalState = useSetRecoilState(messageModalState)

  useEffect(() => {
    const res = addMonth(today, selectedDay)
    setSipDate(res)
  }, [selectedDay, today])

  useEffect(() => {
    refreshMFUserBaskets()
    refreshMFUserSubsequent()
  }, [])

  useEffect(() => {
    const subsequentOneTimeOrSIP =
      (investedPlans &&
        investedPlans?.data?.length &&
        seubsequentPlans?.state === 'hasValue' &&
        seubsequentPlans?.contents?.data?.length > 0 &&
        seubsequentPlans?.contents?.data) ||
      []

    if (state === 'hasValue' && seubsequentPlans?.state === 'hasValue') {
      // Step 1: Get all the relevant admin plans
      const adminCuratedPlans =
        (investedPlans &&
          investedPlans?.data?.length &&
          investedPlans?.data?.filter(
            (plan) =>
              plan?.createdSource === 'ACTION PLAN' &&
              (plan?.sipStatus === 'PENDING' || plan?.oneTimeStatus === 'PENDING'),
          )) ||
        []

      // Step 2: Map and replace matching plans with those from subsequentOneTimeOrSIP
      const updatedPlans = subsequentOneTimeOrSIP?.map((plan) => {
        const match =
          investedPlans &&
          investedPlans?.data?.length &&
          investedPlans?.data?.find(
            (sub) => sub.customerBasketInvestmentId === plan.customerBasketInvestmentId,
          )

        if (
          plan?.orderStatus === 'ACTIVE' &&
          plan?.sipOrderInvestmentAmount &&
          plan?.sipOrderInvestmentBreakdown
        ) {
          return match
            ? {
                ...plan,
                ...match,
                sipInvestmentAmount: plan?.sipOrderInvestmentAmount,
                sipInvestmentBreakdown: plan?.sipOrderInvestmentBreakdown,
                sipStatus: 'PENDING',
                isSubsequentOneTimeOrder: true,
              }
            : { ...plan, sipStatus: 'PENDING' }
        }

        return match
          ? {
              ...plan,
              ...match,
              oneTimeInvestmentAmount: plan?.orderInvestmentAmount,
              oneTimeInvestmentBreakdown: plan?.orderInvestmentBreakdown,
              oneTimeStatus: 'PENDING',
              isSubsequentOneTimeOrder: true,
            }
          : { ...plan, oneTimeStatus: 'PENDING' }
      })

      const allPlans =
        [...adminCuratedPlans, ...updatedPlans]?.map((plan, index) => ({
          ...plan,
          basketIndex: index,
        })) || []

      setAdminPlans(allPlans)
      setSelectedPlans(allPlans)
    }
  }, [state, investedPlans, seubsequentPlans.state])

  useEffect(() => {
    if (isAllSelected && adminPlans?.length) {
      localStorage.setItem('selectedActionPlans', JSON.stringify(adminPlans))
      setSelectedPlans(adminPlans)
    } else if (!isAllSelected) {
      localStorage.removeItem('selectedActionPlans')
      setSelectedPlans([])
    }
  }, [isAllSelected])

  const handleCheckboxChange = (plan) => {
    setSelectedPlans((prev) => {
      const isAlreadySelected = prev.some((p) => p.basketIndex === plan?.basketIndex)
      let updatedPlans

      if (isAlreadySelected) {
        updatedPlans = prev.filter((p) => p.basketIndex !== plan.basketIndex)
      } else {
        updatedPlans = [...prev, plan]
      }

      // Store updated state in localStorage
      localStorage.setItem('selectedActionPlans', JSON.stringify(updatedPlans))

      // // Log updated state
      // console.log('🚀 ~ handleCheckboxChange ~ updatedPlans:', updatedPlans)

      return updatedPlans
    })
  }

  const togglePlan = (id) => {
    setOpenPlans((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const totalLumpsum = selectedPlans
    .filter((plan) => plan?.oneTimeStatus === 'PENDING')
    .reduce((sum, item) => sum + (item.oneTimeInvestmentAmount || 0), 0)

  const totalSip = selectedPlans
    .filter((plan) => plan?.sipStatus === 'PENDING')
    .reduce((sum, item) => sum + (item.sipInvestmentAmount || 0), 0)

  const backHandler = () => {
    navigate(-1)
  }

  const generateOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: email.includes('fabits') ? '' : email,
      },
    )

    if (response.isError) {
      clevertap.event.push('Clicked Button', {
        Action: 'Order OTP Resend Failed',
        Page_name: 'Action Center Orders Page',
      })

      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
    }

    if (!response.isError) {
      clevertap.event.push('Clicked Button', {
        Action: 'Order OTP Resend Successfull',
        Page_name: 'Action Center Orders Page',
      })

      setOpenOTPPopup(true)
    }
  }

  const handleSipOrOT = () => {
    flowStep === 0 ? handleXSips() : placeOneTimeOrder()
  }

  const sipPlans = selectedPlans
    ?.filter((plan) => Number(plan.sipInvestmentAmount) > 0 && plan.sipStatus === 'PENDING')
    ?.filter((fund) => fund?.weightage != 0)

  const oneTimePlans = selectedPlans
    ?.filter((plan) => Number(plan.oneTimeInvestmentAmount) > 0 && plan.oneTimeStatus === 'PENDING')
    ?.filter((fund) => fund?.weightage != 0)

  const calculateParcentageAmount = (parcentage, totalAmount) => {
    const result = totalAmount * (parcentage / 100)
    return Math.ceil(result)
  }

  useEffect(() => {
    if (sipPlans.length) {
      setFlowStep(0)
      return
    }

    if (oneTimePlans.length) {
      setFlowStep(1)
      return
    }
  }, [sipPlans, oneTimePlans])

  const handleXSips = async () => {
    try {
      setLoading(true)

      const sipSum =
        sipPlans
          ?.filter(
            (plan) =>
              plan.sipStatus === 'PENDING' &&
              plan.sipInvestmentAmount &&
              plan.sipInvestmentBreakdown?.length,
          )
          ?.reduce((acc, plan) => acc + plan.sipInvestmentAmount, 0) || 0

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        amount: sipSum.toString(),
        sipStartDate: sipDate,
        mandateType: 'UNIVERSAL',
      }

      const response = await post(
        'mutualfundservice/api/bseStar/mfUpload/mandateRegistration',
        payload,
      )

      setLoading(false)

      if (response?.isError) {
        showError('', getDynamicErrorMessage(response?.response?.data), () => {})

        return
      }

      const sips = sipPlans
        ?.filter(
          (plan) =>
            plan.sipStatus === 'PENDING' &&
            plan.sipInvestmentAmount &&
            plan.sipInvestmentBreakdown?.length,
        )
        .map((plan) => {
          if (plan?.isSubsequentOneTimeOrder) {
            return {
              sipData: plan?.sipInvestmentBreakdown
                ?.filter((p) => p.weightage > 0)
                ?.map((item) => ({
                  schemeCode: item.bseSchemeCode,
                  installmentAmount: calculateParcentageAmount(
                    item.weightage,
                    plan.sipInvestmentAmount,
                  ),
                })),
              clientCode: clientCode?.toUpperCase(),
              startDate: sipDate,
              mandateId: response?.mandateId,
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              isSubsequentOneTimeOrder: plan?.isSubsequentOneTimeOrder,
              subsequentOrderId: plan?.id,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          } else {
            return {
              sipData: plan?.sipInvestmentBreakdown
                ?.filter((p) => p.weightage > 0)
                ?.map((item) => ({
                  schemeCode: item.bseSchemeCode,
                  installmentAmount: calculateParcentageAmount(
                    item.weightage,
                    plan.sipInvestmentAmount,
                  ),
                })),
              clientCode: clientCode?.toUpperCase(),
              startDate: sipDate,
              mandateId: response?.mandateId,
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          }
        })

      if (
        (response?.mandateStatus === 'NEW' || response?.mandateStatus === null) &&
        response?.status === 'SUCCESS'
      ) {
        sessionStorage.setItem(
          'userSIPs',
          JSON.stringify({
            sip: sips,
          }),
        )

        navigate('/dashboard/mutual-funds/mandate', {
          state: {
            mandateId: response?.mandateId,
            clientCode: clientCode?.toUpperCase(),
            sipDate: sipDate,
            isIndividual: false,
            isBasketOrder: false,
            isActionPlan: true,
          },
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        response?.mandateStatus !== 'NEW' &&
        response?.mandateStatus !== null &&
        response?.alreadyExists
      ) {
        const handleSipRegistration = sips?.length && (await handleXSipRegistration(sips))

        if (sips.length && handleSipRegistration.status === 'SUCCESS') {
          // handleSIPUpdate()
          onOpen('openActionPlanPopup', {
            severity: 'sipsuccess',
            title: '',
            message: oneTimePlans?.length
              ? 'Your SIP has been registered successfully. Please continue to complete your one-time investment.'
              : 'Your SIP order has been placed successfully. The transaction has been processed, and your investment will be scheduled accordingly.',
            redirectTo: oneTimePlans?.length ? '/dashboard/firstTime/actionPlanUser' : '/dashboard',
            goBack: '/dashboard',
          })

          refreshMFUserBaskets()
          refreshMFUserSubsequent()
        }
      }
    } catch (error) {
      setLoading(false)
      console.log('🚀 ~ placeSIPOrder ~ error:', error)
    }
  }

  const handleXSipRegistration = async (payload) => {
    try {
      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/multiBasketSipRegistrationOrder',
        payload,
      )

      if (xSIPRegistration?.isError) {
        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => {},
        )
        return
      }

      if (xSIPRegistration?.status === 'SUCCESS') {
        return xSIPRegistration
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)
    }
  }

  const getDynamicErrorMessage = (dataString) => {
    const reason = dataString?.split('|')[6] || ''

    const SupportNote = (
      <>
        <br />
        <span className='text-gray-500'>To update your details, please contact support.</span>
      </>
    )

    if (reason.includes('NOMINEE'))
      return (
        <>
          Nominee authentication is pending. Please complete nominee verification to proceed.
          {SupportNote}
        </>
      )

    if (reason.includes('ELOG'))
      return (
        <>
          E-log verification is pending. Please complete the e-log process before placing an order.
          {SupportNote}
        </>
      )

    if (reason.includes('FATCA'))
      return (
        <>
          Your FATCA declaration is pending. Please update your FATCA details to continue.
          {SupportNote}
        </>
      )

    if (reason.includes('BANK'))
      return (
        <>
          Bank verification failed. Please check your bank details and try again.
          {SupportNote}
        </>
      )

    if (reason.includes('KYC'))
      return (
        <>
          KYC verification is incomplete. Please complete your KYC to proceed.
          {SupportNote}
        </>
      )

    return <>An unknown error occurred while placing your order. Please try again later.</>
  }

  const placeOneTimeOrder = async (payload) => {
    try {
      setLoading(true)
      const payload = oneTimePlans
        ?.filter((plan) => plan.oneTimeInvestmentAmount > 0)
        ?.map((plan) => {
          if (plan?.isSubsequentOneTimeOrder) {
            return {
              orderType: 'PURCHASE',
              isSubsequentOneTimeOrder: plan?.isSubsequentOneTimeOrder,
              subsequentOrderId: plan?.id,
              clientCode: clientCode?.toUpperCase(),
              orderData: plan?.oneTimeInvestmentBreakdown?.map((fund) => ({
                schemeCode: fund.bseSchemeCode,
                orderVal: fund.investmentAmount,
              })),
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          } else {
            return {
              orderType: 'PURCHASE',
              orderData: plan?.oneTimeInvestmentBreakdown?.map((fund) => ({
                schemeCode: fund.bseSchemeCode,
                orderVal: fund.investmentAmount,
              })),
              clientCode: clientCode?.toUpperCase(),
              customerBasketInvestmentId: plan.customerBasketInvestmentId,
              phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
            }
          }
        })

      const response = await post('mutualfundservice/api/basket/multiBasketOneTimeOrder', payload)

      setLoading(false)

      if (response?.isError) {
        showError(
          'Order Placement Failed',
          getDynamicErrorMessage(response?.response?.data),
          () => {},
        )
        return
      }

      // const orderNumberMatch = response.data.match(/ORDER NO: (\d+)/)

      // const orderNumber = orderNumberMatch ? orderNumberMatch[1] : null

      if (response.status === 'SUCCESS') {
        const failures = response.basketResponses
          .map((response) => {
            const failedOrders = response.orders.filter((order) => order.status === 'FAILURE')
            return failedOrders.length > 0 ? { ...response, orders: failedOrders } : null
          })
          ?.filter((response) => response !== null)

        if (failures.length) {
          showError('', getDynamicErrorMessage(response?.response?.data), () => {})
          return
        }

        // console.log(oneTimePlans)
        const basketIds = payload?.map((basket) => basket.customerBasketInvestmentId)

        const orders =
          response?.basketResponses?.length > 0
            ? response?.basketResponses?.flatMap((basket) => basket.orders)
            : []

        sessionStorage.setItem('oneTimeActionPlanOrders', JSON.stringify(orders))

        const lumpsumAmount = oneTimePlans?.reduce(
          (sum, investment) => sum + (investment.oneTimeInvestmentAmount || 0),
          0,
        )

        const paymentPayload = {
          clientCode: clientCode?.toUpperCase(),
          orders: orders,
          lumpsumAmount: lumpsumAmount,
          basketIds: basketIds,
        }

        navigate('/dashboard/actionplan/one-time-payment', {
          state: {
            paymentPayload,
            orderPayload: payload,
          },
        })
      } else {
        showError('Try again later.', getDynamicErrorMessage(response?.response?.data), () => {})
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
    }
  }

  const disableButtons = selectedPlans?.filter(
    (p) => p.sipStatus === 'PENDING' || p.orderStatus === 'ACTIVE' || p.oneTimeStatus === 'PENDING',
  )?.length

  return (
    <div className='md:max-w-[760px] lg:max-w-[1128px] mx-4 md:mx-auto mt-2'>
      <div className='flex gap-x-1 items-center cursor-pointer font-semibold' onClick={backHandler}>
        <ChevronLeft className='h-4' />
        Home
      </div>

      <div>
        <h1 className='flex justify-between items-center mt-4'>
          <span className='font-DMSans font-semibold text-lg md:text-xl text-black-500'>
            Your Plans
          </span>
        </h1>
        <p className='font-DMSans md:text-lg text-sm font-normal text-black-400'>
          Plans have been curated as per your needs
        </p>
      </div>

      <div className='md:flex gap-4 my-4'>
        <div className='py-2 px-3 md:p-5 bg-primary-50 rounded-[7px] flex-1'>
          <h1 className='font-DMSans font-medium md:text-base text-[14px] text-[#4C4C4C] leading-[26px]'>
            One time Investment
          </h1>
          <p className='font-normal md:mt-3 text-2xl md:text-3xl text-primary-600 h-[36px] flex items-end leading-none'>
            <span className='font-DMSans md:text-[1.6rem] font-extrabold mr-2 flex items-end'>
              ₹
            </span>
            <span className='font-OrelegaOne md:text-[28px] tracking-[4%]'>
              {toCurrency(totalLumpsum)}
            </span>
          </p>
        </div>
        <div className='p-3 mt-3 md:mt-0 md:p-5 bg-primary-50 rounded-[7px] flex-1'>
          <h1 className='font-DMSans font-medium md:text-base text-[14px] text-[#4C4C4C] leading-[26px]'>
            SIP (Excluding active SIPs)
          </h1>
          <p className='font-normal md:mt-3 text-2xl md:text-3xl text-primary-600 h-[36px] flex items-end leading-none'>
            <span className='font-DMSans md:text-[1.6rem] font-extrabold mr-2 flex items-end'>
              ₹
            </span>
            <span className='font-OrelegaOne md:text-[28px] tracking-[4%]'>
              {toCurrency(totalSip)}
            </span>
          </p>
        </div>
      </div>

      <div className='mb-2 flex justify-between'>
        <p>Select a plan to proceed</p>
        <span
          className={`font-DMSans font-medium text-sm ${
            isAllSelected ? 'text-black-300' : 'text-primary-600'
          } cursor-pointer`}
          onClick={() => setIsAllSelected(!isAllSelected)}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </span>
      </div>

      <div className='md:flex gap-2 pb-40'>
        <div className='flex-[2] md:grid md:grid-cols-2 lg:grid-cols-2 flex flex-col gap-4 md:gap-4 mb-[170px] overflow-y-scroll hide-scrollbar'>
          {adminPlans?.map((plan, index) => {
            return (
              <div
                key={plan.customerBasketInvestmentId + index}
                className={`border border-[#D3DBEC] py-4 px-3 md:p-5 rounded-[6px] overflow-hidden transition-all duration-300 ease-in-out`}
              >
                <div className='flex justify-between'>
                  <div className='flex gap-3 items-start'>
                    <Checkbox
                      className='h-5 w-5'
                      checked={selectedPlans?.some((p) => p.basketIndex === plan?.basketIndex)}
                      onCheckedChange={() => handleCheckboxChange(plan)}
                    />
                    <img src={placeholder} className='h-6 w-6 md:h-8 md:w-8' alt='plan' />
                    <div className='font-DMSans md:text-lg text-base font-medium'>
                      {plan.customerBasketName}
                    </div>
                  </div>
                </div>

                <div
                  className='flex justify-between mt-3'
                  // onClick={() => togglePlan(plan.customerBasketInvestmentId)}
                >
                  <div className='flex-1'>
                    <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                      One time
                      {/* <span
                        className={`text-xs ${
                          capitalizeWords(plan?.sipStatus) === 'Active'
                            ? 'text-secondary-500 bg-secondary-50 rounded-full px-2 border border-secondary-500'
                            : 'text-warning-500 bg-warning-50 rounded-full px-2  border border-warning-500'
                        }`}
                      >
                        {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                      </span> */}
                    </h1>
                    <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                      ₹
                      {plan.oneTimeInvestmentAmount && plan?.oneTimeStatus === 'PENDING'
                        ? toCurrency(plan.oneTimeInvestmentAmount)
                        : 0}
                    </p>
                    {plan.oneTimeInvestmentAmount > 0 && plan?.oneTimeStatus === 'PENDING' && (
                      <p
                        className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                        onClick={() => {
                          onOpen('oneTimeBreakdown', {
                            constituents: plan?.oneTimeInvestmentBreakdown?.filter(
                              (fund) => fund?.weightage != 0,
                            ),
                          })
                        }}
                      >
                        View Funds
                      </p>
                    )}
                  </div>

                  {(plan?.sipStatus === 'PENDING' || plan?.sipStatus === 'ACTIVE') && (
                    <div className='flex-1'>
                      <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                        SIP{' '}
                        <span
                          className={`text-xs ${
                            capitalizeWords(plan?.sipStatus) === 'Active'
                              ? 'text-secondary-500 bg-secondary-50 rounded-full px-2 border border-secondary-500'
                              : 'text-warning-500 bg-warning-50 rounded-full px-2  border border-warning-500'
                          }`}
                        >
                          {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                        </span>
                      </h1>

                      <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                        ₹{plan.sipInvestmentAmount ? toCurrency(plan.sipInvestmentAmount) : 0}
                      </p>

                      {plan.sipInvestmentAmount > 0 && (
                        <p
                          className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                          onClick={() => {
                            onOpen('sipBreakdown', {
                              constituents: plan?.sipInvestmentBreakdown?.filter(
                                (fund) => fund?.weightage != 0,
                              ),
                              totalAmount: plan?.sipInvestmentAmount,
                            })
                          }}
                        >
                          View Funds
                        </p>
                      )}
                    </div>
                  )}
                </div>

                <div onClick={() => togglePlan(plan.customerBasketInvestmentId)}>
                  {openPlans[plan.customerBasketInvestmentId] && (
                    <>
                      {((plan.sipInvestmentAmount > 0 && !plan.oneTimeInvestmentAmount) ||
                        (plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount > 0)) && (
                        <div className='my-3 md:mt-5 border-t border-[#D3DBEC]'>
                          {plan?.sipInvestmentBreakdown?.length > 0 &&
                            plan?.sipInvestmentBreakdown?.map((breakup, index) => {
                              const percentage =
                                (breakup.investmentAmount / plan.sipInvestmentAmount) * 100
                              return (
                                <div
                                  key={index}
                                  className='flex mt-3 justify-between items-center gap-10'
                                >
                                  <div className='flex gap-2 items-center'>
                                    <img
                                      src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                      alt={`${breakup.name} icon`}
                                      className='rounded-[8px] h-6 w-6 md:h-8 md:w-8'
                                    />
                                    <p className='font-DMSans text-sm font-medium text-black-500'>
                                      {isDesktop
                                        ? breakup?.schemeName
                                        : `${breakup?.schemeName.slice(0, 20)}...`}
                                    </p>
                                  </div>
                                  <p className='font-DMSans text-sm font-medium text-black-500'>
                                    {percentage}%
                                  </p>
                                </div>
                              )
                            })}
                        </div>
                      )}

                      {plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount === 0 && (
                        <div className='my-3 md:mt-5 border-t border-[#D3DBEC]'>
                          {plan?.oneTimeInvestmentBreakdown.length > 0 &&
                            plan?.oneTimeInvestmentBreakdown?.map((breakup, index) => {
                              const percentage =
                                (breakup.investmentAmount / plan.oneTimeInvestmentAmount) * 100
                              return (
                                <div
                                  key={index}
                                  className='flex mt-3 justify-between items-center gap-10'
                                >
                                  <div className='flex gap-2 items-center'>
                                    <img
                                      src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                      alt={`${breakup.name} icon`}
                                      className='rounded-[8px] h-6 w-6 md:h-8 md:w-8'
                                    />
                                    <p className='font-DMSans text-sm font-medium text-black-500'>
                                      {isDesktop
                                        ? breakup?.schemeName
                                        : `${breakup?.schemeName.slice(0, 20)}...`}
                                    </p>
                                  </div>
                                  <p className='font-DMSans text-sm font-medium text-black-500'>
                                    {percentage}%
                                  </p>
                                </div>
                              )
                            })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div
        className={`fixed bottom-0 left-0 right-0 p-4 z-10 lg:max-w-[1128px] mx-auto bg-white mt-2`}
        style={{ boxShadow: '0px 4px 21.6px 0px #00000040', borderRadius: '24px 24px 0px 0px' }}
      >
        <div className='mx-auto space-y-2'>
          {flowStep === 0 && (
            <>
              <div className='mt-4'>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant={'outline'}
                      className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                    >
                      <span className='text-primary-500 flex items-center gap-x-2'>
                        <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                        <p>
                          SIP starts on -{' '}
                          <b>
                            {addNumberSuffix(sipDate.split('/')[0])}{' '}
                            {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                            {sipDate.split('/')[2]}
                          </b>
                        </p>
                      </span>

                      <Pen className='h-4 w-4 text-primary-500' />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                    <div className='flex gap-x-2 p-2'>
                      {sipDates.map((day, index) => (
                        <Button
                          key={(day + index).toString()}
                          className={`h-8 w-8 rounded-full inline-block ${
                            selectedDay !== +day
                              ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                              : 'text-white'
                          }`}
                          size='simple'
                          onClick={() => setSelectedDay(+day)}
                        >
                          {day}
                        </Button>
                      ))}
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            </>
          )}

          {/* <div className='my-6'>
            <UserBankDetails day={addNumberSuffix(+selectedDay)} flowStep={flowStep} />
          </div> */}

          {isDematUser() ? (
            <Button
              disabled={disableButtons <= 0}
              className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-300`}
              onClick={generateOTP}
              loading={loading}
            >
              Continue
            </Button>
          ) : (
            <Button
              disabled={disableButtons <= 0}
              className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-300`}
              onClick={() =>
                setMessageModalState({
                  message: 'Your KYC is incomplete.',
                  linkMessage:
                    'Click here to complete your KYC and to enable hassle free, one-click investing.',
                  severity: 'info',
                })
              }
            >
              Complete your KYC
            </Button>
          )}

          {flowStep === 0 && (
            <p className='text-xs mt-2 text-center font-semibold'>
              Keep your internet banking password ready for quick setup.
            </p>
          )}

          {openOTPPopup && (
            <OrderOtpVerification
              phoneNumber={userDetails?.phoneNumber}
              openOTPPopup={openOTPPopup}
              setOpenOTPPopup={setOpenOTPPopup}
              email={email}
              handleSipOrOT={handleSipOrOT}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default UserActionPlan
